var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect2, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect3, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _rect4, _path25, _rect5, _path26, _rect6, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _path27, _path28, _path29, _path30;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersistenceColdPlunge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 279,
    height: 137,
    viewBox: "0 0 279 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 32,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#D5EEFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.915 62.4863L16.3848 62.7697L17.7876 76.798C18.0393 79.3147 20.157 81.2312 22.6862 81.2312H43.3141C45.8433 81.2312 47.961 79.3147 48.2127 76.798L49.6155 62.7697L48.0853 62.4863C46.9002 62.2668 45.6848 62.2668 44.4996 62.4863L41.4392 63.0531C40.254 63.2725 39.0386 63.2725 37.8534 63.0531L34.793 62.4863C33.6079 62.2668 32.3925 62.2668 31.2073 62.4863L28.1469 63.0531C26.9617 63.2725 25.7463 63.2725 24.5611 63.0531L21.5007 62.4863C20.3155 62.2668 19.1001 62.2668 17.915 62.4863Z",
    fill: "#75C5F4",
    stroke: "#57B2E8",
    strokeWidth: 2.46152
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 44.9219L33 53.5373",
    stroke: "#2C94DA",
    strokeWidth: 2.46154
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 41.8467L33 56.6159",
    stroke: "#2C94DA",
    strokeWidth: 2.46154
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3945 45.5391L26.6044 52.9237",
    stroke: "#2C94DA",
    strokeWidth: 2.46154
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6055 45.5381L39.3956 52.9227",
    stroke: "#2C94DA",
    strokeWidth: 2.46154
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6152 75.0773L18.7612 74.8481C20.0359 74.5932 21.3484 74.5932 22.6231 74.8481L24.915 75.3065C26.1897 75.5614 27.5023 75.5614 28.777 75.3065L31.0689 74.8481C32.3436 74.5932 33.6561 74.5932 34.9308 74.8481L37.2227 75.3065C38.4974 75.5614 39.81 75.5614 41.0847 75.3065L43.3766 74.8481C44.6513 74.5932 45.9638 74.5932 47.2385 74.8481L48.3845 75.0773",
    stroke: "#57B2E8",
    strokeWidth: 2.46152
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17 68.923L18.3406 68.6652C19.5689 68.429 20.8311 68.429 22.0594 68.6652L24.7406 69.1808C25.9689 69.417 27.2311 69.417 28.4594 69.1808L31.1406 68.6652C32.3689 68.429 33.6311 68.429 34.8594 68.6652L37.5406 69.1808C38.7689 69.417 40.0311 69.417 41.2594 69.1808L43.9406 68.6652C45.1689 68.429 46.4311 68.429 47.6594 68.6652L49 68.923",
    stroke: "#57B2E8",
    strokeWidth: 2.46152
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1534 56.6152H54.6856C52.1564 56.6152 50.0387 58.5318 49.787 61.0484L48.2121 76.7974C47.9604 79.3141 45.8427 81.2306 43.3135 81.2306H22.6856C20.1564 81.2306 18.0387 79.3141 17.787 76.7974L16.2121 61.0484C15.9604 58.5318 13.8427 56.6152 11.3135 56.6152H10.8457",
    stroke: "#2C94DA",
    strokeWidth: 2.46152,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 32,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#D5EEFC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M113.915 62.4863L112.385 62.7697L113.788 76.798C114.039 79.3147 116.157 81.2312 118.686 81.2312H139.314C141.843 81.2312 143.961 79.3147 144.213 76.798L145.616 62.7697L144.085 62.4863C142.9 62.2668 141.685 62.2668 140.5 62.4863L137.439 63.0531C136.254 63.2725 135.039 63.2725 133.853 63.0531L130.793 62.4863C129.608 62.2668 128.392 62.2668 127.207 62.4863L124.147 63.0531C122.962 63.2725 121.746 63.2725 120.561 63.0531L117.501 62.4863C116.316 62.2668 115.1 62.2668 113.915 62.4863Z",
    fill: "#75C5F4",
    stroke: "#57B2E8",
    strokeWidth: 2.46152
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M129 44.9219L129 53.5373",
    stroke: "#2C94DA",
    strokeWidth: 2.46154
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M129 41.8467L129 56.6159",
    stroke: "#2C94DA",
    strokeWidth: 2.46154
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M135.395 45.5391L122.604 52.9237",
    stroke: "#2C94DA",
    strokeWidth: 2.46154
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M122.605 45.5381L135.396 52.9227",
    stroke: "#2C94DA",
    strokeWidth: 2.46154
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M113.615 75.0773L114.761 74.8481C116.036 74.5932 117.348 74.5932 118.623 74.8481L120.915 75.3065C122.19 75.5614 123.502 75.5614 124.777 75.3065L127.069 74.8481C128.344 74.5932 129.656 74.5932 130.931 74.8481L133.223 75.3065C134.497 75.5614 135.81 75.5614 137.085 75.3065L139.377 74.8481C140.651 74.5932 141.964 74.5932 143.239 74.8481L144.384 75.0773",
    stroke: "#57B2E8",
    strokeWidth: 2.46152
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M113 68.923L114.341 68.6652C115.569 68.429 116.831 68.429 118.059 68.6652L120.741 69.1808C121.969 69.417 123.231 69.417 124.459 69.1808L127.141 68.6652C128.369 68.429 129.631 68.429 130.859 68.6652L133.541 69.1808C134.769 69.417 136.031 69.417 137.259 69.1808L139.941 68.6652C141.169 68.429 142.431 68.429 143.659 68.6652L145 68.923",
    stroke: "#57B2E8",
    strokeWidth: 2.46152
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M151.153 56.6152H150.686C148.156 56.6152 146.039 58.5318 145.787 61.0484L144.212 76.7974C143.96 79.3141 141.843 81.2306 139.313 81.2306H118.686C116.156 81.2306 114.039 79.3141 113.787 76.7974L112.212 61.0484C111.96 58.5318 109.843 56.6152 107.313 56.6152H106.846",
    stroke: "#2C94DA",
    strokeWidth: 2.46152,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 24,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#D5EEFC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M206.143 62.1074L204.23 62.4616L205.984 79.997C206.299 83.1429 208.946 85.5385 212.107 85.5385H237.892C241.054 85.5385 243.701 83.1429 244.015 79.997L245.769 62.4616L243.856 62.1074C242.375 61.8331 240.855 61.8331 239.374 62.1074L235.548 62.8158C234.067 63.0902 232.548 63.0902 231.066 62.8158L227.241 62.1074C225.759 61.8331 224.24 61.8331 222.759 62.1074L218.933 62.8158C217.452 63.0902 215.932 63.0902 214.451 62.8158L210.625 62.1074C209.144 61.8331 207.625 61.8331 206.143 62.1074Z",
    fill: "#75C5F4",
    stroke: "#57B2E8",
    strokeWidth: 3.0769
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M225 40.1533L225 50.9226",
    stroke: "#2C94DA",
    strokeWidth: 3.07692
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M225 36.3076L225 54.7692",
    stroke: "#2C94DA",
    strokeWidth: 3.07692
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M232.993 40.9229L217.005 50.1536",
    stroke: "#2C94DA",
    strokeWidth: 3.07692
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M217.007 40.9229L232.995 50.1536",
    stroke: "#2C94DA",
    strokeWidth: 3.07692
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M205.77 77.8464L207.202 77.5599C208.795 77.2412 210.436 77.2412 212.029 77.5599L214.894 78.1329C216.488 78.4515 218.128 78.4515 219.722 78.1329L222.587 77.5599C224.18 77.2412 225.821 77.2412 227.414 77.5599L230.279 78.1329C231.872 78.4515 233.513 78.4515 235.106 78.1329L237.971 77.5599C239.565 77.2412 241.205 77.2412 242.799 77.5599L244.231 77.8464",
    stroke: "#57B2E8",
    strokeWidth: 3.0769
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M205 70.154L206.676 69.8317C208.211 69.5365 209.789 69.5365 211.324 69.8317L214.676 70.4763C216.211 70.7715 217.789 70.7715 219.324 70.4763L222.676 69.8317C224.211 69.5365 225.789 69.5365 227.324 69.8317L230.676 70.4763C232.211 70.7715 233.789 70.7715 235.324 70.4763L238.676 69.8317C240.211 69.5365 241.789 69.5365 243.324 69.8317L245 70.154",
    stroke: "#57B2E8",
    strokeWidth: 3.0769
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M252.692 54.7695H252.108C248.946 54.7695 246.299 57.1652 245.984 60.3111L244.016 79.9972C243.701 83.1431 241.054 85.5388 237.892 85.5388H212.108C208.946 85.5388 206.299 83.1431 205.984 79.9972L204.016 60.311C203.701 57.1652 201.054 54.7695 197.892 54.7695H197.308",
    stroke: "#2C94DA",
    strokeWidth: 3.0769,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 78,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M153.5 94L157.5 98L164.5 90",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 78,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 94L61.5 98L68.5 90",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 239,
    y: 78,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 94,
    r: 2,
    fill: "#24284E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 247,
    cy: 94,
    r: 2,
    fill: "#24284E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 263,
    cy: 94,
    r: 2,
    fill: "#24284E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 133,
    r: 2,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 24,
    r: 2,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 126.5,
    r: 1.5,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 5.5,
    r: 1.5,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 130.5,
    r: 1.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 105.5,
    r: 1.5,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 275.5,
    cy: 127.5,
    r: 1.5,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.5,
    cy: 3.5,
    r: 1.5,
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 277.5,
    cy: 34.5,
    r: 1.5,
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M174.5 11L185 23",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M262 3.5L251.5 17.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M195 111L184.5 125",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M243.5 122.5L250 135",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistenceColdPlunge);
export default __webpack_public_path__ + "static/media/persistence-cold-plunge.e5a5d18f234bf4b29540bd15c208f056.svg";
export { ForwardRef as ReactComponent };